module.exports = __webpack_public_path__ + "img/banner_account.b00096b1.png";